import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import LocationalState, {LocationalRoadObject} from "../LocationalState";
import {RoadObjectInfoFeature} from "./RoadObjectInfoFeature";
import {LocationalDetailsModal} from "./LocationalDetailsModal";

interface TagProps {
}

interface DispatchProps {
}

interface StateProps {
    selectedRoadObjects: LocationalRoadObject[],
    showModal: boolean
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        selectedRoadObjects: selectors.selectedRoadObjects(state),
        showModal: selectors.showLocationalDetailsModal(state)
    };
};

const mapDispatchToProps: DispatchProps = ({});

class Component extends React.Component<Props, {}> {

    render() {
        const {selectedRoadObjects, showModal} = this.props;
        const numberOfSelectedRoadObjects: number = selectedRoadObjects.length;

        let roadObjectInfo;

        if (numberOfSelectedRoadObjects == 0) {
            roadObjectInfo = (
                <div>
                    <h4>Ingen vegobjekter er valgt</h4>
                </div>
            );
        }

        else if (numberOfSelectedRoadObjects <= 5) {
            let list = selectedRoadObjects.map(
                ro => {
                    return (
                        <div key={ro.id}>
                            <RoadObjectInfoFeature feature={ro} />
                        </div>
                    )
                }
            );
            roadObjectInfo = (
                <div>{list}</div>
            )
        }

        else {
            roadObjectInfo = (
                <div>
                    <h4>{numberOfSelectedRoadObjects} vegobjekter er valgt</h4>
                </div>
            )
        }

        return (
            <div className={"roadObjectInfo"}>
                {roadObjectInfo}
                {showModal &&
                    <LocationalDetailsModal />
                }
            </div>
        );
    }
}

export const RoadObjectInfo = connect(mapStateToProps, mapDispatchToProps)(Component);